export const validateField = (name, value, regex, t) => {
  if (!value) return t("validation.required");

  if (!regex?.test(value)) {
    switch (name) {
      case "email":
        return t("validation.emailInvalid");
      case "password":
        return t("validation.passwordInvalid");
      case "firstName":
        return t("validation.firstNameInvalid");
      case "lastName":
        return t("validation.lastNameInvalid");
      case "phone":
        return t("validation.phoneInvalid");
      default:
        return t("validation.required");
    }
  }

  return "";
};
